<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Late Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="late_fee" type="text" placeholder="Late fee" :class="{ 'is-danger': errors.late_fee }">
                    <span class="icon is-left">
                       <i class="fas fa-dollar-sign"></i>
                    </span>
                    <p v-if="errors.late_fee" class="help is-danger">{{ errors.late_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            late_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.late_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'late_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/LateFee.vue